module.exports = __webpack_public_path__ + "static/img/bkite14.7c3b1c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/bkite14.jpg
// module id = Gn2f
// module chunks = 0